import { Alert } from 'antd';

import { getTranslatedString } from '@/utils';

interface FormInfoAlertProps {
  name?: string;
  i18nTitle: string;
  i18nDescription?: string;
}

/** Non-input block for generic forms (e.g. campaign season explanation). */
export function FormInfoAlert({ i18nTitle, i18nDescription }: FormInfoAlertProps) {
  return (
    <div style={{ marginBottom: 20 }}>
      <Alert
        type="info"
        showIcon
        message={getTranslatedString(i18nTitle)}
        description={i18nDescription ? getTranslatedString(i18nDescription) : undefined}
      />
    </div>
  );
}
